import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import type { IFormInputs } from "types/uiSchema";
import { FormItem as BaseFormItem, FormControl, FormField, FormLabel } from "uiShadcn/form";
import { RadioGroup, RadioGroupItem } from "uiShadcn/radio-group";

export interface RadioProps {
    control: FormControlType;
    uiData: IFormInputs;
}

export default function Radio({ control, uiData }: RadioProps) {
    const name = uiData["x-json-schema-reference-property"];
    const isRequired = uiData?.required?.includes("true");

    const dictionary = uiData["x-dictionary"];

    if (!name || dictionary?.length === 0) return null;

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem label={uiData.description} required={isRequired}>
                    <FormControl>
                        <RadioGroup
                            onValueChange={field.onChange}
                            defaultValue={field.value}
                            className="flex flex-col space-y-1"
                            dataTestId={`RadioGroup-${field.name}`}
                            name={name}
                            required={isRequired}
                        >
                            {dictionary?.map(({ key, value }) => (
                                <BaseFormItem key={key} className="flex items-center gap-n2">
                                    <FormControl>
                                        <RadioGroupItem
                                            value={key.toString()}
                                            dataTestId={`RadioGroupItem-${field.name}-${key}`}
                                            aria-label={value}
                                        />
                                    </FormControl>
                                    <FormLabel>{value}</FormLabel>
                                </BaseFormItem>
                            ))}
                        </RadioGroup>
                    </FormControl>
                </FormItem>
            )}
        />
    );
}
